.root input::placeholder {
  opacity: 0.42;
}

.endAdornment {
  top: 40% !important;
  right: 9px !important;
}
